import DetailStatus from "./detailStatus.jsx";

export default DetailStatus;
